import axios from "@/modules/shared/AxiosInterceptor"
import { DraftOrder } from "@/types/draftOrder.types"
import {
  EcommerceAuthenticatePayload,
  EcommerceAuthenticateResponse,
  EcommerceIntegration,
  ECommercePlatforms,
  EcommerceValidatePayload,
  EcommerceValidateResponse,
} from "@/types/ecommerce"
import { AxiosResponse } from "axios"

const baseUrl = "/integrations/ecommerce"

export async function postEcommerceAuthenticate(
  payload: EcommerceAuthenticatePayload
): Promise<AxiosResponse<EcommerceAuthenticateResponse>> {
  try {
    return axios.post(`${baseUrl}/${payload?.request?.platform}/authenticate`, payload)
  } catch (error) {
    throw error
  }
}

export async function postEcommerceValidate({
  platform,
  data,
  integrationId,
}: EcommerceValidatePayload): Promise<AxiosResponse<EcommerceValidateResponse>> {
  try {
    return axios.post(`${baseUrl}/${platform}`, { integrationId, data })
  } catch (error) {
    throw error
  }
}

export async function getEcommerceIntegrations(): Promise<AxiosResponse<EcommerceIntegration[]>> {
  try {
    return axios.get(`${baseUrl}`)
  } catch (error) {
    throw error
  }
}

export async function getEcommerceOrders(payload: any): Promise<AxiosResponse<DraftOrder[]>> {
  try {
    return axios.post(`${baseUrl}/${payload.platform}/${payload.id}/orders`, {
      storeID: payload.storeId,
    })
  } catch (error) {
    throw error
  }
}

export async function deleteEcommerceShop(
  platform: ECommercePlatforms,
  integrationId: string
): Promise<AxiosResponse> {
  try {
    return axios.delete(`${baseUrl}/${platform}/${integrationId}`)
  } catch (error) {
    throw error
  }
}

export async function getEcommerceShippingRules(
  integrationId: string
): Promise<AxiosResponse<any>> {
  try {
    return axios.get(`${baseUrl}/${integrationId}/shipping_rules`)
  } catch (error) {
    throw error
  }
}

export async function putEcommerceShippingRules(
  integrationId: string,
  shippingRuleId: string,
  dispatchRuleId: string
): Promise<AxiosResponse<any>> {
  try {
    return axios.put(`${baseUrl}/${integrationId}/shipping_rules/${shippingRuleId}`, {
      dispatchRuleId: dispatchRuleId || null,
    })
  } catch (error) {
    throw error
  }
}
